import { render, staticRenderFns } from "./RequestNewManageServices.vue?vue&type=template&id=b497e21e&"
import script from "./RequestNewManageServices.vue?vue&type=script&lang=js&"
export * from "./RequestNewManageServices.vue?vue&type=script&lang=js&"
import style0 from "./RequestNewManageServices.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports